export default {
    // 端点
    loginEndpoint: '/jwt/login',
    registerEndpoint: '/jwt/register',
    refreshEndpoint: '/jwt/refresh-token',
    logoutEndpoint: '/logout',
    authorizationUrl: process.env.VUE_APP_OAUTH2_URL + '/oauth2/authorize',
    getTokenUrl: process.env.VUE_APP_OAUTH2_URL + '/oauth2/token',

    // 客户端配置
    clientId: 'home-client',
    clientSecret: '123456',
    grantType: 'authorization_code',
    redirectUri: 'http://192.168.31.120:8089/loading',
    scope: 'message.read',

    // 客户端配置2
    clientId2: 'home-client2',
    redirectUri2: 'http://www.xmhgapi.com/teacherLibrary',

    // 客户端配置3
    clientId3: 'home-client2',
    redirectUri3: 'http://www.xmhgapi.com/teacherLibrary',



    // This will be prefixed in authorization header with token
    // e.g. Authorization: Bearer <token>
    tokenType: 'Bearer',

    //此属性的值将用作在存储中存储 JWT 令牌的键
    storageTokenKeyName: 'Authorization',
    storageRefreshTokenKeyName: 'refreshToken',
}
